import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";

export const welcomeResult = (d) => {
  const extra = [d.no_email?.length && `${d.no_email.length} senza email`, d.no_plan?.length && `${d.no_plan.length} senza piano`, d.already_sent && `${d.already_sent} già ricevuta`].filter(Boolean).join(", ");
  toast.success(`Welcome mail inviata a ${d.sent} student${d.sent === 1 ? "e" : "i"}${extra ? ` · ${extra}` : ""}`);
};

export function WelcomeButton({ rows }) {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const withPlan = rows.filter((r) => r.plan);
  const notSent = withPlan.filter((r) => !r.plan.welcome_sent_at).length;
  const send = useMutation({
    mutationFn: async (only_not_sent) => (await api.post("/modular-payments/welcome", { all: true, only_not_sent })).data,
    onSuccess: (d) => { welcomeResult(d); setOpen(false); qc.invalidateQueries({ queryKey: ["mod-payments"] }); },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });
  return (
    <>
      <Button onClick={() => setOpen(true)} className="rounded-full bg-[#1C352D] hover:bg-[#14271f]" data-testid="mp-welcome-btn"><Send size={14} className="mr-1.5"/> Welcome mail</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="mp-welcome-dialog">
          <DialogHeader>
            <DialogTitle>Invia la welcome mail</DialogTitle>
            <DialogDescription>Email di benvenuto con il piano di rate, IBAN, link PayPal e carta (dalle Impostazioni di Iscrizioni).</DialogDescription>
          </DialogHeader>
          <div className="text-sm text-stone-600">{withPlan.length} studenti con piano di pagamento · <b>{notSent}</b> non l'hanno ancora ricevuta.</div>
          <div className="flex flex-col gap-2">
            <Button disabled={!notSent || send.isPending} onClick={() => send.mutate(true)} className="bg-[#1C352D] hover:bg-[#14271f]" data-testid="mp-welcome-not-sent">Invia solo a chi non l'ha ricevuta ({notSent})</Button>
            <Button variant="outline" disabled={!withPlan.length || send.isPending} onClick={() => window.confirm(`Inviare la welcome mail a tutti i ${withPlan.length} studenti?`) && send.mutate(false)} data-testid="mp-welcome-all">Invia a tutti ({withPlan.length})</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
